"use strict";

exports.__esModule = true;
exports.getOnRowClick = getOnRowClick;
var _moment = _interopRequireDefault(require("moment"));
var _libCalendar = require("@vimana/lib-calendar");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function getOnRowClick(props) {
  var selectedRowIndex = props.selectedRowIndex,
    setSelectedRowIndex = props.setSelectedRowIndex,
    resetSelectedRowIndex = props.resetSelectedRowIndex,
    calendar = props.calendar,
    columns = props.columns,
    setSelection = props.setSelection,
    componentPath = props.componentPath,
    wrappingInterval = props.wrappingInterval;
  return function (rowInfo) {
    if (!rowInfo) {
      return;
    }
    var shouldSelectRow = selectedRowIndex !== rowInfo.index;
    shouldSelectRow ? setSelectedRowIndex(rowInfo.index) : resetSelectedRowIndex();
    if (!shouldSelectRow) {
      return;
    }

    // Set the selection context after the row is selected
    var row = rowInfo.original;
    var selectionContext = {};
    Object.keys(row).forEach(function (k) {
      var cellValue = row[k];
      if (typeof cellValue === "string" && cellValue.trim() === "") {
        return;
      }
      if (k === "workday") {
        var day = cellValue.slice(0, 10);
        var _calendar$getInterval = calendar.getIntervalForWorkdays([day]),
          startMillis = _calendar$getInterval.startMillis;
        var column = columns.find(function (col) {
          return col.id === k;
        });
        if (!column) {
          return;
        }
        var intervalType = column.type;
        var endMillis = (0, _moment["default"])(startMillis).add(1, intervalType).valueOf();
        var interval = {
          startMillis: Math.max(wrappingInterval.startMillis, startMillis),
          endMillis: Math.min(wrappingInterval.endMillis, endMillis)
        };
        selectionContext.reportingPeriod = {
          interval: interval
        };
        return;
      }

      // TODO, NOTE: Smell ahead!
      // Need to migrate ui-config of reports. Which is why adding this now.
      if (k === "kind") {
        selectionContext.part_kind = cellValue;
        return;
      }

      // shift is an array in data, but is rendered as `shift.join(", ")`
      if (k === "shift") {
        selectionContext[k] = cellValue.split(", ");
        return;
      }
      // End of smells

      selectionContext[k] = cellValue;
    });
    setSelection(selectionContext, componentPath);
  };
}